import { Box } from '@mui/material';
import React, { PropsWithChildren } from 'react';

const PageHeaderImageAndTextWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      {children}
    </Box>
  );
};

export default PageHeaderImageAndTextWrapper;
